import { render, staticRenderFns } from "./SideBarTabs.vue?vue&type=template&id=46cc9d71&scoped=true&"
import script from "./SideBarTabs.vue?vue&type=script&lang=js&"
export * from "./SideBarTabs.vue?vue&type=script&lang=js&"
import style0 from "./SideBarTabs.vue?vue&type=style&index=0&id=46cc9d71&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cc9d71",
  null
  
)

export default component.exports